import { DataGridFormDefinition } from "src/components/common/dataGrid/types";
import { GridRowId } from "@mui/x-data-grid-pro";
import { GridApiPro } from "@mui/x-data-grid-pro/models/gridApiPro";
import { logError } from "src/errorHandling/errorLogging";
import { AnyError } from "src/errorHandling/anyError";
import { OpenGenericDialogFunc } from "src/components/common/dialogs/GenericDialogProvider.tsx";
import { FormResult } from "src/components/common/forms/types.ts";

export const openFormForDataGridRow = async <RowData extends object>(
	{
		row,
		openDialog,
		form,
		refreshData,
		gridApi
	}: {
		openDialog: OpenGenericDialogFunc,
		form: DataGridFormDefinition<RowData> | undefined,
		row: RowData | undefined,
		refreshData: () => Promise<unknown>,
		gridApi: GridApiPro
	}
) => {
	if (form === undefined) return;

	const onCloseFormDialog = async (result: FormResult<GridRowId | undefined>) => {
		if (result.type === "success") {
			await refreshData();
			const editedRowId = result.value;
			if (editedRowId !== undefined) {
				// Select the new or edited row.
				// setTimeout() is used to delay selection a bit to ensure
				// that the new row is added to the grid.
				setTimeout(() => {
					gridApi.selectRow(editedRowId, true, true);
				}, 0);
			}
		}
	};

	openDialog(({ closeDialog, onContentEdited }) => ({
		size: form.dialogSize,
		title: form.dialogTitle,
		children: form.component({
			row: row,
			onFormEdited: onContentEdited,
			onCompleted: async (result) => {
				try {
					await closeDialog({
						confirmIfEdited: result.type === "cancel"
					});
					await onCloseFormDialog(result);
				} catch (e) {
					logError(e as AnyError);
				}
			}
		})
	}));
};
